export default __webpack_public_path__ + "static/homepage-3-a1700a65390bc33f78d0c56c6dd38720.png";